import React, { SetStateAction, useEffect, useState } from 'react';
import { Button, Card, Form, Row } from 'react-bootstrap';
import { CampaignsService } from '../../campaigns/CampaignsService';
import { Campaign } from '../../../model/campaign/Campaign';
import AutocompleteInput from '../../../shared/components/AutocompleteInput';
import { ErrorToast } from '../../../utils/toasters';

interface IReportingFilters {
    setPagination: React.Dispatch<SetStateAction<any>>;
    setReportingTrigger: (...args: any) => void;
}

const ReportingFilters = ({ setPagination, setReportingTrigger }: IReportingFilters) => {
    const [campaigns, setCompaigns] = useState<Campaign[]>([]);
    const [filterCampaigns, setFilterCampaigns] = useState('');

    useEffect(() => {
        CampaignsService.getCampaigns({ page: 1, perPage: 10, title: filterCampaigns })
            .then(data => {
                setCompaigns(data.data);
            })
            .catch(err => ErrorToast(err));
    }, [filterCampaigns]);

    return (
        <Card
            className="mb-5"
            onKeyDown={(e: any) => {
                if (e.key === 'Enter') setReportingTrigger((prev: boolean) => !prev);
            }}
        >
            <Card.Body>
                <Row>
                    <Form.Group className="m-0 col-4">
                        <div className="autocomplete-input zindex-5 position-relative">
                            <AutocompleteInput
                                placeholder={'Campaign'}
                                value={filterCampaigns}
                                items={campaigns}
                                renderItems={['title']}
                                setFilter={value => {
                                    setFilterCampaigns(value);
                                    if (!value) setPagination((prev: any) => ({ ...prev, campaignId: undefined }));
                                }}
                                onSelect={campaign => {
                                    setPagination((prev: any) => ({ ...prev, campaignId: campaign?.id }));
                                    setFilterCampaigns(campaign?.title);
                                }}
                            />
                        </div>
                    </Form.Group>

                    <Form.Group className="m-0 col-auto">
                        <div className="autocomplete-input zindex-5 position-relative">
                            <Button onClick={() => setReportingTrigger((prev: boolean) => !prev)}>Search</Button>
                        </div>
                    </Form.Group>
                </Row>
            </Card.Body>
        </Card>
    );
};

export default ReportingFilters;
